import { ApiContext } from "../../contexts/ApiContext";
import { useContext } from "react";
import { useQuery } from "react-query";

export function useDomainMappings(customerId?: number) {
  const apiContext = useContext(ApiContext);
  return useQuery({
    queryKey: ["domainMappings", customerId],
    queryFn: async () => {
      if (customerId) return await apiContext.domainMappingsApis.getDomainMapping(customerId);
    },
  });
}
